import { Button } from '@mui/material'
import * as React from 'react'
import DialogComponent from '../DialogComponent/DialogComponent'
import { AnalyticService } from '../../lib/analytics/analyticService'
import HubspotLoanApplicationForm from './HubspotLoanApplicationForm'

const HubspotLoanApplicationFormDialogButton = (props: {
  buttonText: string
  buttonVariant?: 'text' | 'contained' | 'outlined'
  buttonStyle?: React.CSSProperties
  buttonSize?: 'small' | 'medium' | 'large'
}) => {
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleToggleDialog = () => {
    if (!openDialog) {
      AnalyticService.onAdminHubspotDialogOpened()
    }
    setOpenDialog(!openDialog)
  }

  return (
    <>
      <Button
        onClick={handleToggleDialog}
        variant={props.buttonVariant || 'outlined'}
        size={props.buttonSize || 'medium'}
        color={'primary'}
        disableElevation={true}
        style={props.buttonStyle}
      >
        {props.buttonText.length ? props.buttonText : 'Apply for loan'}
      </Button>
      <DialogComponent
        contentPadding="0px"
        title="Apply for a course loan"
        fullScreen={false}
        onRequestClose={handleToggleDialog}
        open={openDialog}
        content={<HubspotLoanApplicationForm />}
      />
    </>
  )
}

export default HubspotLoanApplicationFormDialogButton
